import { stateUpdateApi } from "../../api/state/stateUpdateApi"

type PayloadShape = Parameters<typeof stateUpdateApi>[0]

export async function stateUpdateService(payload: PayloadShape, token: string) {
	return await stateUpdateApi(payload, token)
}
